import { acceptOnlyValidPayments } from './payment-input-normalize-value';
export const paymentInputViewer = {
    normalizeLoadedValue: acceptOnlyValidPayments
};

//# sourceMappingURL=definition-viewer.js.map